import { useMemo, useState } from "react";
import {
  useRecoilCallback,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import useImageProfessional from "src/Professional/hooks/useImageProfessional";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import { dayDefaultAvailableState } from "../components/calendars/state/atoms";
import {
  dayAvailableDefaultFetchState,
  daysAvailableFetchState,
  dayAvailableDefaultImagenologiaFetchState,
  daysAvailableImagenologiaFetchState,
  daysAvailableState,
  filterSearchSelectedState,
  hoursAvailableFetchState,
  hoursAvailableImagenologiaFetchState,
  hoursAvailableState,
  loadingDaysCalendarState,
  loadingHoursState,
  professionalsMatchCovenantState,
  professionalsNoMatchCovenantState,
  reservationCanceledFecthState,
  reservationCanceledState,
  dayAvailableDefaultProcedimientoFetchState,
  daysAvailableProcedimientoFetchState,
  hoursAvailableProcedimientoFetchState,
} from "../state/atoms";
import { agendamientoInconclusoState } from "src/ResultSearch/state/atoms";

const useSearchHours = () => {
  const { catchErrorApi } = useCatchErrorApi();
  const setDaysAvailable = useSetRecoilState(daysAvailableState);
  const filterSearchSelected = useRecoilValue(filterSearchSelectedState);
  const setDayDefaultAvailable = useSetRecoilState(dayDefaultAvailableState);
  const setHoursAvailable = useSetRecoilState(hoursAvailableState);
  const setReservationCanceled = useSetRecoilState(reservationCanceledState);
  const setLoadingDaysCalendar = useSetRecoilState(loadingDaysCalendarState);
  const [loading, setLoading] = useState(false);
  const setLoadingHours = useSetRecoilState(loadingHoursState);
  const resetDayDefaultAvailable = useResetRecoilState(
    dayDefaultAvailableState
  );
  const resetDaysAvailableState = useResetRecoilState(daysAvailableState);
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);
  const resetProfessionalsMatchCovenant = useResetRecoilState(
    professionalsMatchCovenantState
  );
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(
    professionalsNoMatchCovenantState
  );
  const dayDefaultAvailable = useRecoilValue(dayDefaultAvailableState);

  const { loadImageProfessional } = useImageProfessional();

  const setValueAgendamientoInconcluso = useSetRecoilState(
    agendamientoInconclusoState
  );

  const getDaysAvailable = useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        //setLoadingHours(true)
        //setLoadingDaysCalendar(true);
        //const release = snapshot.retain();
        try {
          const daysAvailable = await snapshot.getPromise(
            daysAvailableFetchState
          );
          setDaysAvailable(daysAvailable);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          //setLoadingDaysCalendar(false)
        }
      },
    []
  );

  const loadDaysAvailableAndDefault = useRecoilCallback(
    ({ snapshot, reset }) =>
      async () => {
        setLoadingDaysCalendar(true);
        // reset(dayDefaultAvailableState)
        // reset(daysAvailableState)
        const release = snapshot.retain();
        try {
          const dayDefault = await snapshot.getPromise(
            dayAvailableDefaultFetchState
          );
          setValueAgendamientoInconcluso((prev) => ({
            ...prev,
            agiFechaBuscada: dayDefault,
          }));
          setDayDefaultAvailable(dayDefault);

          const daysAvailable = await snapshot.getPromise(
            daysAvailableFetchState
          );
          setDaysAvailable(daysAvailable);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          release();
          setLoadingDaysCalendar(false);
        }
      },
    []
  );

  // ---------------- IMAGENOLOGIA ----------------
  const loadDaysAvailableImagenologiaAndDefault = useRecoilCallback(
    ({ snapshot, reset }) =>
      async () => {
        setLoadingDaysCalendar(true);
        // reset(dayDefaultAvailableState)
        // reset(daysAvailableState)
        const release = snapshot.retain();
        try {
          const dayDefault = await snapshot.getPromise(
            dayAvailableDefaultImagenologiaFetchState
          );
          setValueAgendamientoInconcluso((prev) => ({
            ...prev,
            agiFechaBuscada: dayDefault,
          }));
          setDayDefaultAvailable(dayDefault);

          const daysAvailable = await snapshot.getPromise(
            daysAvailableImagenologiaFetchState
          );
          setDaysAvailable(daysAvailable);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          release();
          setLoadingDaysCalendar(false);
        }
      },
    []
  );

  const loadDReservationCanceled = useRecoilCallback(
    ({ snapshot }) =>
      async (uuid) => {
        try {
          const reservatioCanceled = await snapshot.getPromise(
            reservationCanceledFecthState(uuid)
          );
          setReservationCanceled(reservatioCanceled);

          return reservatioCanceled;
        } catch (error) {
          catchErrorApi(error);
        }
      },
    []
  );

  const resetSearchAndResultHours = () => {
    resetDayDefaultAvailable();
    resetDaysAvailableState();
    resetHoursAvailable();
    resetProfessionalsMatchCovenant();
    resetProfessionalsNoMatchCovenant();
  };

  const loadHoursAvailable = useRecoilCallback(
    ({ snapshot, reset }) =>
      async () => {
        setLoadingHours(true);
        reset(hoursAvailableState);
        reset(professionalsMatchCovenantState);
        reset(professionalsNoMatchCovenantState);

        try {
          const hoursAvailable = await snapshot.getPromise(
            hoursAvailableFetchState
          );
          setHoursAvailable(hoursAvailable);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoadingHours(false);
        }
      },
    []
  );

  // const devolverImgImagenologia = (rut) => {
  //     let url = "";

  //     let sede = process.env.REACT_APP_SEDE;

  //     if(sede == 'Puerto Montt'){

  //         if(rut.trim() == '108'){
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img_eco.jpg`;
  //         } else if (rut.trim() == '94') {
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/51.jpg`;
  //         } else if (rut.trim() == '86') {
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/78.jpg`;
  //         } else if (rut.trim() == '51') {
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/43.jpg`;
  //         } else{
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img-rx.jpg`;
  //         }

  //     }else{
  //         if(rut.trim() == '19'){
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img_eco.jpg`;
  //         } else if (rut.trim() == '43') {
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/43.jpg`;
  //         } else if (rut.trim() == '51') {
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/51.jpg`;
  //         } else if (rut.trim() == '78') {
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/78.jpg`;
  //         } else if (rut.trim() == '94') {
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/94.jpg`;
  //         } else if (rut.trim() == '108') {
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/108.jpg`;
  //         }
  //         else{
  //             url = `${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/img-rx.jpg`;
  //         }
  //     }

  //     return url
  // }

  const loadHoursImagenologiaAvailable = useRecoilCallback(
    ({ snapshot, reset }) =>
      async () => {
        setLoadingHours(true);
        reset(hoursAvailableState);
        reset(professionalsMatchCovenantState);
        reset(professionalsNoMatchCovenantState);

        try {
          const hoursAvailable = await snapshot.getPromise(
            hoursAvailableImagenologiaFetchState
          );
          const hoursAvailableModificado = hoursAvailable.map((hour) => ({
            ...hour,
            imagen: loadImageProfessional(hour.ptdRut),
          }));

          setHoursAvailable(hoursAvailableModificado);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoadingHours(false);
        }
      },
    []
  );

  const isEmptyFilters = () => {
    return (
      filterSearchSelected.professionalSelected.value === "" &&
      filterSearchSelected.specialitySelected.value === ""
    );
  };

  const isEmptyFiltersImagenologia = () => {
    return (
      filterSearchSelected.tipoExamenSelected.value === "" &&
      filterSearchSelected.examenSelected.value === ""
    );
  };

  const dayDefaultValue = useMemo(() => {
    return dayDefaultAvailable;
  }, [dayDefaultAvailable]);

  // ---------------- PROCEDIMIENTO ----------------
  const loadDaysAvailableProcedimientoAndDefault = useRecoilCallback(
    ({ snapshot, reset }) =>
      async () => {
        setLoadingDaysCalendar(true);
        // reset(dayDefaultAvailableState)
        // reset(daysAvailableState)
        const release = snapshot.retain();
        try {
          const dayDefault = await snapshot.getPromise(
            dayAvailableDefaultProcedimientoFetchState
          );
          setValueAgendamientoInconcluso((prev) => ({
            ...prev,
            agiFechaBuscada: dayDefault,
          }));
          setDayDefaultAvailable(dayDefault);

          const daysAvailable = await snapshot.getPromise(
            daysAvailableProcedimientoFetchState
          );
          setDaysAvailable(daysAvailable);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          release();
          setLoadingDaysCalendar(false);
        }
      },
    []
  );

  const loadHoursProcedimientoAvailable = useRecoilCallback(
    ({ snapshot, reset }) =>
      async () => {
        setLoadingHours(true);
        reset(hoursAvailableState);
        reset(professionalsMatchCovenantState);
        reset(professionalsNoMatchCovenantState);

        try {
          const hoursAvailable = await snapshot.getPromise(
            hoursAvailableProcedimientoFetchState
          );
          setHoursAvailable(hoursAvailable);
        } catch (error) {
          catchErrorApi(error);
        } finally {
          setLoadingHours(false);
        }
      },
    []
  );

  const isEmptyFiltersProcedimiento = () => {
    return (
      filterSearchSelected.servicioSelected.value === "" &&
      filterSearchSelected.procedimientoSelected.value === ""
    );
  };

  return {
    loadDaysAvailableAndDefault,
    loadDaysAvailableImagenologiaAndDefault,
    loadDaysAvailableProcedimientoAndDefault,
    loadHoursAvailable,
    loadHoursImagenologiaAvailable,
    loadHoursProcedimientoAvailable,
    isEmptyFilters,
    isEmptyFiltersImagenologia,
    isEmptyFiltersProcedimiento,
    resetSearchAndResultHours,
    loadDReservationCanceled,
    setLoadingDaysCalendar,
    setLoadingHours,
    getDaysAvailable,
    loading,
    setLoading,
    dayDefaultValue,
  };
};

export default useSearchHours;
